import PageHeader from "../components/pageHeader";
import bishop from "../assets/bishop-paul-ravichandran.jpg";
import bishop1 from "../assets/bishop1.png";
import bishop2 from "../assets/bishop2.png";
import bishop3 from "../assets/bishop3.png";
import "./bishopPage.css";

export default function BishopPage() {
  return (
    <div>
      <div className="soft-red-bg px-4">
        <PageHeader title="Bishop in Madras" />
      </div>

      <main className="bishop-page">
        <section className="bishop-profile">
          <div className="bishop-portrait-wrap">
            <img
              src={bishop}
              className="bishop-portrait"
              alt="Rt. Rev. Dr. A.Paul Francis Ravichandran, Bishop in Madras"
            />
          </div>

          <div className="bishop-content">
            <p className="bishop-eyebrow">THE DIOCESE OF MADRAS</p>
            <h1 className="bishop-name">Rt. Rev. Dr. A.Paul Francis Ravichandran</h1>
            <p className="bishop-role">Bishop in Madras</p>

            <blockquote className="bishop-quote">
              &ldquo;Grace and peace to you in the name of our Lord Jesus Christ.&rdquo;
            </blockquote>

            <div className="bishop-copy">
              <p>
                The Rt. Rev. Dr. A. Paul Francis Ravichandran is the Bishop of the Church of South India (CSI), Diocese of Madras. Consecrated on 3 August 2025 at the historic CSI St. George’s Cathedral on Cathedral Road, Chennai, he leads the Diocese in worship, witness and service, strengthening its ministry among churches, educational institutions and communities.
              </p>
              <p>
                Born on 18 March 1965, he was ordained a Deacon in 1993 and a Presbyter in 1994 at CSI St. George’s Cathedral, Chennai. He studied at Madras Christian College and holds a Bachelor of Divinity (B.D.) from the United Theological College, Bengaluru. With more than three decades of pastoral ministry, he has served congregations across the Diocese of Madras and held significant leadership responsibilities at diocesan and synod levels.
              </p>
              <p>
                Known for his compassionate ministry and commitment to the marginalised, Bishop Ravichandran is often regarded as the “People’s Bishop.” A man of God and a friend to the lost and the last, he is an eloquent orator, convention speaker, pulpit preacher and prolific writer. His ministry reflects a deep concern for the voiceless and the disadvantaged, transcending barriers of caste, colour and creed, both within and beyond the Church.
              </p>
              <p>
                Beyond his diocesan responsibilities, he serves as President of the National Missionary Society (NMS), an Executive Committee Member of the World Communion of Reformed Churches (WCRC), and President of the Christian Literature Society (CLS), Chennai. Through his pastoral leadership, public witness and commitment to compassionate service, he continues to inspire others to live out Christian values of faith, justice, love and service.
              </p>
            </div>

            <div className="bishop-signature">
              <p>With prayers and blessings,</p>
              <p className="bishop-signature-name">Rt. Rev. Dr. A.Paul Francis Ravichandran</p>
              <p>Bishop in Madras</p>
            </div>
          </div>
        </section>

        <section className="bishop-milestones" aria-labelledby="bishop-milestones-title">
          <div className="bishop-milestones-heading">
            <p className="bishop-eyebrow">A LIFE OF SERVICE</p>
            <h2 id="bishop-milestones-title">Ministry, leadership and witness</h2>
            <p>
              A journey shaped by pastoral care, faithful leadership and a
              lifelong commitment to the people of the Church.
            </p>
          </div>

          <div className="bishop-milestone-grid">
            <article className="bishop-milestone-card">
              <img src={bishop1} alt="Bishop Paul Francis Ravichandran" />
              <div className="bishop-card-body">
                <p className="bishop-card-number">01</p>
                <h3>Pastoral ministry</h3>
                <p>
                  His ministry spans over three decades, serving congregations across Annamalai Nagar, Walajabad, East Tambaram, Choolai, Selaiyur, Kodambakkam, Kattumannarkovil and Ashok Nagar.
                </p>
              </div>
            </article>

            <article className="bishop-milestone-card bishop-card-featured">
              <img src={bishop2} alt="Bishop Paul Francis Ravichandran" />
              <div className="bishop-card-body">
                <p className="bishop-card-number">02</p>
                <h3>Diocesan leadership</h3>
                <p>
                  Consecrated on 3 August 2025, he leads the CSI Diocese of Madras. He also serves as President of the National Missionary Society and as an Executive Committee Member of the WCRC.
                </p>
              </div>
            </article>

            <article className="bishop-milestone-card">
              <img src={bishop3} alt="Bishop Paul Francis Ravichandran" />
              <div className="bishop-card-body">
                <p className="bishop-card-number">03</p>
                <h3>Family &amp; recognition</h3>
                <p>
                  Known as the “People’s Bishop,” he champions the marginalised and gives a voice to the voiceless. He also serves as President of the Christian Literature Society, Chennai, promoting Christian faith and literature.
                </p>
              </div>
            </article>
          </div>
        </section>
      </main>
    </div>
  );
}
